import classNames from 'classnames';
import { bool, string } from 'prop-types';

import PopupPlain, {
  propTypes as popupPlainPropTypes,
} from '~/components/PopupPlain';

import styles from './PopupClassic.module.scss';

const PopupClassic = ({
  className,
  containerClassName,
  dismissButtonClassName,
  big,
  ...props
}) => (
  <PopupPlain
    containerClassName={classNames(
      styles.dialogModal,
      { [styles.big]: big },
      containerClassName,
    )}
    fullscreen={big}
    buttonClassName={classNames(styles.dismissButton, dismissButtonClassName)}
    className={classNames(styles.modalContent, className)}
    {...props}
  />
);

export const propTypes = {
  ...popupPlainPropTypes,
  big: bool,
  dismissButtonClassName: string,
};

PopupClassic.propTypes = propTypes;

PopupClassic.defaultProps = {
  big: true,
};

export default PopupClassic;
